/* tslint:disable */
/* eslint-disable */
export enum PosProviderType {
  RestaurantIntegration = 'RestaurantIntegration',
  PosSpi = 'POS_SPI'
}
